import type {FC} from 'react';

import Color from 'color';
import styled, {css} from 'styled-components';

import type {Variant} from '../ToolBoxButton/types';
import type {Size} from './types';

import {ms, square} from '../../styles';
import {View} from '../../uikit/View';
import {platform} from '../../utils/platform';
import {getClientBgColor, getCoachBgColor} from '../ToolBoxButton/utils';

export const Container = styled(View)<{size: Size}>`
  position: relative;
  align-items: center;
  justify-content: center;
  ${square(64)}

  ${p =>
    p.size === 'sm' &&
    css`
      ${square(48)}
    `}
`;

type IconProps = {
  component: FC<{fill?: string}> | number | string;
  isFilled: boolean;
  variant: Variant;
};

export const Icon = styled(
  ({component, isFilled, variant, ...rest}: IconProps) => {
    let fill: string | undefined;

    if (variant !== 'food_diary') {
      if (isFilled) {
        fill = Color(getCoachBgColor(variant))
          .darken(0.3)
          .saturate(0.2)
          .toString();
      } else {
        fill = Color(getClientBgColor(variant)).lighten(0.3).toString();
      }
    }

    // React Native: PNG imports are numbers
    if (
      platform.isNative &&
      (typeof component === 'number' || typeof component === 'string')
    ) {
      const RNImage = require('react-native').Image;
      const source =
        typeof component === 'number' ? component : {uri: component};

      return <RNImage source={source} {...rest} />;
    }

    // Web: PNG imports are strings
    if (typeof component === 'string') {
      return <img src={component} {...rest} alt="" />;
    }

    // At this point, component must be FC (SVG component)
    if (typeof component === 'function') {
      const Component = component;

      return <Component {...rest} fill={fill} />;
    }

    return null;
  },
)`
  width: ${ms(64)};
  height: ${ms(64)};

  ${p =>
    p.variant !== 'food_diary' &&
    css`
      width: ${ms(30)};
      height: ${ms(30)};
    `}

  ${p =>
    (p.variant === 'food_diary' || p.variant === 'trackers') &&
    platform.isNative &&
    css`
      width: ${ms(64)};
      height: ${ms(64)};
    `}

  ${p =>
    (p.variant === 'food_diary' || p.variant === 'trackers') &&
    platform.isWeb &&
    css`
      ${square(64)};
    `}
`;
